import React, { Component } from 'react';
import { authentication } from '../services/Authentication';
import { withRouter } from "react-router-dom";
import { config } from '../Constants';
import helpers from '../Function';
import moment from 'moment';

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Multiselect from 'react-widgets/lib/Multiselect'
import TablePagination from '@material-ui/core/TablePagination';
import $ from "jquery";

class Users extends Component {

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission } = authentication.currentUserValue;
        this.state = {
            userid: user_id,
            user_permission: user_permission,
            miss_suc: helpers.getUserType(user_type, "suc"),
            miss_su: helpers.getUserType(user_type, "su"),
            pages: [],
            project_home: [],
            add_project_home: [],
            user_types: [],
            updateIsOpen: false,
            deleteIsOpen: false,
            logoutIsOpen: false,
            dupIsOpen: false,
            jwt: jwt,
            usertype: user_type,
            create_by: name,
            create_by_id: user_id,
            addIsOpen: false,
            srcIsOpen: false,
            add_id: '',
            add_first_name: '',
            add_last_name: '',
            add_fullname: '',
            add_username: '',
            add_password: '',
            add_nickname: '',
            add_phone: '',
            add_phone_office: '',
            add_email: '',
            val_project: '',
            add_project: '',
            val_permission: '',
            add_permission: '',
            content_id: '',
            page: 0,
            rowsPerPage: 10,
            src_name: '',
            src_phone: '',
            src_project: '',
            src_permission: '',
            add_house: [],
            addhouse: [],
            add_house_name: "",
        }

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.closeAdd = this.closeAdd.bind(this);
        this.openAdd = this.openAdd.bind(this);
        this.submitAdd = this.submitAdd.bind(this);

        this.openEdit = this.openEdit.bind(this);
        this.submitEdit = this.submitEdit.bind(this);
        this.openView = this.openView.bind(this);

        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);

        this.change = this.change.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);


        this.openDelete = this.openDelete.bind(this);
        this.submitDelete = this.submitDelete.bind(this);
        this.closeDelete = this.closeDelete.bind(this);

        this.submitlogout = this.submitlogout.bind(this);
        this.openlogout = this.openlogout.bind(this)
        this.closelogout = this.closelogout.bind(this);

        this.closeModelUpdate = this.closeModelUpdate.bind(this);
        this.closeDuplicate = this.closeDuplicate.bind(this);

        this.user_types()
        this.project_home()
        this.dataTable();

    }

    project_home() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/project_homes', requestOptions)
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    let sortData = data.data.sort(function (a, b) {
                        return a.num - b.num;
                    });
    
                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });
    
                    let FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });
    
                    this.setState({
                        project_home: [{ value: '', display: 'เลือกโครงการ' }, { value: "", display: 'ทุกโครงการ' }].concat(FromApi),
                        add_project_home: found2
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    user_types() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/permissionUserType?active=true', requestOptions)
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    let FromApi = data.data.map(datas => {
                        return { value: datas.id, display: datas.name }
                    });
    
                    this.setState({
                        user_types: [{ value: '', display: 'เลือกสิทธิ์การใช้งาน' }].concat(FromApi)
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    dataTable() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            var type = '';
    
            if (this.state.miss_su) {
                type = "su"
            } else if (this.state.miss_suc) {
                type = "suc"
            }
    
            fetch(config.url.API_URL + '/useradmin/?usertype=' + type
                + '&phone=' + (this.state.src_phone ? this.state.src_phone : '')
                + '&projecthomeid=' + (this.state.src_project ? this.state.src_project : '')
                + '&permission=' + (this.state.src_permission ? this.state.src_permission : '')
                + '&name=' + (this.state.src_name ? this.state.src_name : '')
                , requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data)) {
                        var FromApi = data.data.map(datas => {
                            return {
                                id: datas._id,
                                full_name: datas.first_name + " " + datas.last_name,
                                username: datas.username,
                                first_name: datas.first_name,
                                last_name: datas.last_name,
                                nickname: datas.nick_name,
                                login: datas.login,
                                login_adm_nir: helpers.getUserOnline(datas.login_adm_nir),
                                phone: datas.phone,
                                email: datas.email,
                                login: datas.login_adm_nir,
                                //permission: helpers.getPermission(datas.user_type[0].user_type),
                                masteruser_types: datas.masteruser_types,
                                active_status: helpers.getActiveStatus(datas.active_status),
                                updateby: datas.updateby == undefined ? datas.createby : datas.updateby,
                                updated: datas.updated != undefined ? `${moment(datas.updated).format("DD/MM/YYYY HH:mm น.")}` : `${moment(datas.created).format("DD/MM/YYYY HH:mm น.")}`,
                            }
                        });
                    }
    
                    this.setState({
                        pages: [].concat(FromApi),
                        srcIsOpen: false
                    });
                }).catch(error => {
                    console.log(error)
                    // //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            // //window.location.reload(); // Reload the page 
        }
    }

    openAdd() {
        this.setState({
            add_id: '',
            add_first_name: '',
            add_last_name: '',
            add_fullname: '',
            add_username: '',
            add_password: '',
            add_nickname: '',
            add_phone: '',
            add_phone_office: '',
            add_email: '',
            val_project: '',
            add_project: '',
            val_permission: '',
            add_permission: '',
            addIsOpen: true,
            methodOpen: 'add',
            add_house: []
        });
    }

    openEdit(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/useradmin/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    var datas = data.data[0];
                    //
                    this.setState({
                        add_id: datas._id,
                        add_first_name: datas.first_name,
                        add_last_name: datas.last_name,
                        add_fullname: datas.first_name + " " + datas.last_name,
                        add_username: datas.username,
                        add_nickname: datas.nick_name,
                        add_phone: datas.phone,
                        add_phone_office: datas.phone_office,
                        add_email: datas.email,
                        val_project: datas.project_home_id === null ? "0" : datas.project_home_id,
                        add_house: datas.project_home_id === null ? "0" : datas.project_home_id,
                        add_project: (Array.isArray(datas.project_homes) && datas.project_homes.length ? datas.project_homes[0].name_th : ''),
                        val_permission: datas.masteruser_types.length > 0 ? datas.masteruser_types[0]._id : "",
                        add_permission: datas.masteruser_types.length > 0 ? datas.masteruser_types[0].name : "",
                        addIsOpen: true,
                        methodOpen: 'edit'
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitEdit(e) {
        try {
            if (this.state.add_house.length > 0) {
                if (this.state.add_house[0].id != undefined) {
                    this.state.addhouse = []
                    this.state.add_house.forEach(element => {
                        this.state.addhouse.push(element.id)
                    });
                }
            } else {
                this.state.addhouse = []
            }
    
    
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    first_name: this.state.add_first_name,
                    last_name: this.state.add_last_name,
                    username: this.state.add_username,
                    password: this.state.add_password,
                    nick_name: this.state.add_nickname,
                    phone: this.state.add_phone,
                    phone_office: this.state.add_phone_office,
                    email: this.state.add_email,
                    project_home_id: this.state.addhouse.length > 0 ? this.state.addhouse : this.state.add_house,
                    //user_type: [{ user_type: this.state.val_permission }],
                    usertype_id: this.state.val_permission,
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id,
                    login: 0
                }),
            };
    
            fetch(config.url.API_URL + '/useradmin/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            this.setState({
                add_id: '',
                add_first_name: '',
                add_last_name: '',
                add_fullname: '',
                add_username: '',
                add_password: '',
                add_nickname: '',
                add_phone: '',
                add_phone_office: '',
                add_email: '',
                val_project: '',
                add_project: '',
                val_permission: '',
                add_permission: '',
                addIsOpen: false
            });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openView(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/useradmin/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    var datas = data.data[0];
                    var project_home_name = ``
                    if (datas.project_homes.length) {
                        datas.project_homes.forEach(element => {
                            project_home_name += `${element.name_th},`
                        });
    
                        var str = project_home_name;
                        var newStr = str.slice(0, -1);
                    }
                    this.setState({
                        add_id: datas._id,
                        add_first_name: datas.first_name,
                        add_last_name: datas.last_name,
                        add_fullname: datas.first_name + " " + datas.last_name,
                        add_username: datas.username,
                        add_nickname: datas.nick_name,
                        add_phone: datas.phone,
                        add_phone_office: datas.phone_office,
                        add_email: datas.email,
                        val_project: datas.project_home_id,
                        add_project: (Array.isArray(datas.project_homes) && datas.project_homes.length ? datas.project_homes[0].name_th : ''),
                        add_house_name: newStr,
                        val_permission: datas.masteruser_types.length > 0 ? datas.masteruser_types[0].id : "",
                        add_permission: datas.masteruser_types.length > 0 ? datas.masteruser_types[0].name : "",
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeAdd() {
        this.setState({ addIsOpen: false });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    closeDuplicate() {
        this.setState({ dupIsOpen: false });
        this.dataTable();
    }

    closeDelete() {
        this.setState({ deleteIsOpen: false });
        this.dataTable();
    }

    closelogout() {
        this.setState({ logoutIsOpen: false });
        this.dataTable();
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            content_id: e.currentTarget.attributes["data-id"].value
        });
    }

    openlogout(e) {
        this.setState({
            logoutIsOpen: true,
            content_id: e.currentTarget.attributes["data-id"].value
        });
    }

    submitDelete(e) {
        try {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/deleteuser/' + this.state.content_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        spinner: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            this.setState({ deleteIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitlogout(e) {
        try {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/useradmin/' + this.state.content_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        spinner: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            this.setState({ logoutIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openSrc(e) {
        this.setState({
            src_name: '',
            src_phone: '',
            src_project: '',
            src_permission: '',
            val_permission: '',
            srcIsOpen: true,
            page: 0
        });
    }

    submitSrc(e) {
        this.dataTable();
        this.setState({ srcIsOpen: false });
    }

    submitAdd() {
        try {
            if (!this.state.add_first_name) {
                alert('ไม่พบข้อมูลชื่อ');
                return;
            }
    
            if (!this.state.add_last_name) {
                alert('ไม่พบข้อมูลนามสกุล');
                return;
            }
            if (!this.state.add_username) {
                alert('ไม่พบข้อมูลชื่อเข้าใช้');
                return;
            }
            if (!this.state.add_password) {
                alert('ไม่พบข้อมูลรหัสผ่าน');
                return;
            }
            if (!this.state.add_email) {
                alert('ไม่พบข้อมูลอีเมล');
                return;
            }
            if (!this.state.add_phone) {
                alert('ไม่พบข้อมูลเบอร์โทรศัพท์');
                return;
            }
            if (!this.state.val_permission) {
                alert('ไม่พบข้อมูลสิทธิ์');
                return;
            }
    
            if (this.state.add_house.length > 0) {
                if (this.state.add_house[0].id != undefined) {
                    this.state.add_house.forEach(element => {
                        this.state.addhouse.push(element.id)
                    });
                }
            } else {
                this.state.addhouse = []
            }
    
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    first_name: this.state.add_first_name,
                    last_name: this.state.add_last_name,
                    username: this.state.add_username,
                    password: this.state.add_password,
                    nick_name: this.state.add_nickname,
                    phone: this.state.add_phone,
                    phone_office: this.state.add_phone_office,
                    email: this.state.add_email,
                    //project_home_id: this.state.add_house,
                    project_home_id: this.state.addhouse.length > 0 ? this.state.addhouse : this.state.add_house,
                    //user_type: [{ user_type: this.state.val_permission }],
                    usertype_id: this.state.val_permission,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/useradmin/', requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (data.status == "Success") {
                        this.setState({
                            updateIsOpen: true,
                            addIsOpen: false
                        });
                    } else {
                        this.setState({
                            dupIsOpen: true,
                            addIsOpen: false
                        });
                    }
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    render() {

        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        //console.log("***********************"+JSON.stringify(test));
        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Users List</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">users</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    {(this.state.user_permission[180].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>
                                    )}
                                </div>

                                <div className="card-body">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: '10px' }}>No.</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่อ-นามสกุล</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>Username</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>ชื่อเล่น</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>เบอร์ติดต่อ</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>อีเมล</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>สิทธิ์การใช้งาน</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>สถานะ</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>สถานะการ online/offline</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={i}>
                                                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                                                    <StyledTableCell>{data.full_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.username}</StyledTableCell>
                                                                    <StyledTableCell>{data.nickname}</StyledTableCell>
                                                                    <StyledTableCell>{data.phone}</StyledTableCell>
                                                                    <StyledTableCell>{data.email}</StyledTableCell>
                                                                    <StyledTableCell>{data.masteruser_types.length > 0 ? data.masteruser_types[0].name : ""}</StyledTableCell>
                                                                    <StyledTableCell>{data.active_status}</StyledTableCell>
                                                                    <StyledTableCell>{data.login_adm_nir}</StyledTableCell>
                                                                    {data.updateby != undefined && <StyledTableCell>{data.updateby}<br />{data.updateby == undefined ? data.updated : data.updated}</StyledTableCell>}
                                                                    {data.updateby == undefined && <StyledTableCell>{data.updated}</StyledTableCell>}
                                                                    <StyledTableCell>
                                                                        <button className="btn-action text-center" data-id={data.id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>
                                                                        {(this.state.user_permission[181].permission == 1 && this.state.userid !== data.id &&
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" /> Update</button>
                                                                        )}
                                                                        {(this.state.user_permission[182].permission == 1 && this.state.userid !== data.id &&
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openDelete}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>
                                                                        )}
                                                                        {(data.login === 1 && this.state.userid !== data.id &&
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openlogout}><img src="dist/img/icon/ic_logout_01.png" className="btn-icon" alt="" /> logout</button>
                                                                        )}
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
                {/* /.content */}
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อ</div>
                                <div className="col-sm-6">
                                    <input type="text" className="form-control" defaultValue={this.state.src_name} id="src_name" name="src_name" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">เบอร์โทรศัพท์</div>
                                <div className="col-sm-6">
                                    <input type="text" className="form-control" defaultValue={this.state.src_phone} id="src_phone" name="src_phone" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โครงการรับผิดชอบ</div>
                                <div className="col-sm-6">
                                    <select className="form-control" id="src_project" name="src_project" style={{ height: 45 }} onChange={this.change}>
                                        {
                                            this.state.project_home.map((datas, i) =>
                                                <option key={i} value={datas.value}>{datas.display}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">สิทธิ์การใช้งาน</div>
                                <div className="col-sm-6">
                                    <select className="form-control" id="src_permission" name="src_permission" style={{ height: 45 }} onChange={this.change}>
                                        {this.state.user_types.map((datas, i) => <option key={i} value={datas.value} >{datas.display}</option>)}
                                    </select>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl">
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อ-นามสกุล<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-6">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<div className="row">
                                            <input type="text" className="form-control col-sm-5" id="add_first_name" name="add_first_name" style={{ marginLeft: "8px" }} defaultValue={this.state.add_first_name} onChange={this.change} />
                                            <input type="text" className="form-control col-sm-5" id="add_last_name" name="add_last_name" style={{ marginLeft: "8px" }} defaultValue={this.state.add_last_name} onChange={this.change} /></div>)
                                        : (<div className="form-control">{this.state.add_fullname}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">Username<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-6">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" defaultValue={this.state.add_username} id="add_username" name="add_username" onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_username}</div>)}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">Password<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-6">
                                    <input type="password" className="form-control" id="add_password" name="add_password" onChange={this.change} />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อเล่น</div>
                                <div className="col-sm-6">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" defaultValue={this.state.add_nickname} id="add_nickname" name="add_nickname" onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_nickname}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">เบอร์โทรศัพท์<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-6">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" defaultValue={this.state.add_phone} id="add_phone" name="add_phone" onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_phone}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">เบอร์ที่ทำงาน</div>
                                <div className="col-sm-6">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" defaultValue={this.state.add_phone_office} id="add_phone_office" name="add_phone_office" onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_phone_office}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">อีเมล<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-6">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" defaultValue={this.state.add_email} id="add_email" name="add_email" onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_email}</div>)}
                                </div>
                            </div>
                            {/* <div className="row mb-3">
                                <div className="col-sm-3 text-right">โครงการรับผิดชอบ</div>
                                <div className="col-sm-6">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<select className="form-control" id="val_project" name="val_project" style={{ height: 45 }} onChange={this.change}>
                                            {this.state.project_home.map((datas, i) => <option key={i} value={datas.value} selected={this.state.val_project === datas.value && "selected"}>{datas.display}</option>)}
                                        </select>)
                                        : (<div className="form-control">{this.state.add_project}</div>)}
                                </div>
                            </div> */}
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โครงการรับผิดชอบ</div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<Multiselect
                                            data={this.state.add_project_home}
                                            valueField='id'
                                            textField='name_th'
                                            defaultValue={this.state.add_house}
                                            onChange={add_house =>
                                                this.setState({
                                                    add_house: add_house
                                                })
                                            }
                                        />)
                                        : (<TextareaAutosize className="form-control" name="add_house_name" rowsMin={1} defaultValue={this.state.add_house_name} disabled />)
                                    }
                                </div>
                            </div>
                            {/*<option value="acc" selected={(this.state.val_permission==='cc' && 'selected')}>Admin Center Call Center</option>
                                        <option value="amp" selected={(this.state.val_permission==='amp' && 'selected')}>Admin Marketing Project</option>
                                        <option value="cc" selected={(this.state.val_permission==='cc' && 'selected')}>Call Center</option>
                                        <option value="dop" selected={(this.state.val_permission==='rep' && 'selected')}>Digital Online / Presale</option>
                                        <option value="jf" selected={(this.state.val_permission==='jf' && 'selected')}>Juristic / Facility</option>
                                        <option value="mp" selected={(this.state.val_permission==='mp' && 'selected')}>Marketing Project</option>
                                        <option value="pay" selected={(this.state.val_permission==='rep' && 'selected')}>Payment</option>
                                        <option value="su" selected={(this.state.val_permission==='su' && 'selected')}>Super Admin</option>
                                        <option value="suc" selected={(this.state.val_permission==='suc' && 'selected')}>Super Callcenter</option>
                                        <option value="rep" selected={(this.state.val_permission==='rep' && 'selected')}>แจ้งซ่อม</option>
                                        <option value="cp" selected={(this.state.val_permission==='suc' && 'selected')}>ร้องเรียน</option>*/}
                            {/*
                            <option value="acc" selected={(this.state.val_permission==='acc' && 'selected')}>Admin Center Call Center</option>
                                            <option value="cc" selected={(this.state.val_permission==='cc' && 'selected')}>Call Center</option>
                                            <option value="su" selected={(this.state.val_permission==='su' && 'selected')}>Super Admin</option>
                                            <option value="suc" selected={(this.state.val_permission==='suc' && 'selected')}>Super Callcenter</option>
                            */}
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">สิทธิ์การใช้งาน<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-6">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<select className="form-control" id="val_permission" name="val_permission" style={{ height: 45 }} onChange={this.change}>
                                            {this.state.user_types.map((datas, i) => <option key={i} value={datas.value} selected={this.state.val_permission === datas.value && "selected"}>{datas.display}</option>)}
                                        </select>)
                                        : (<div className="form-control">{this.state.add_permission}</div>)}
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-success" onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.dupIsOpen} onHide={this.closeDuplicate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        User นี้มีในระบบแล้ว
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDuplicate}>ปิด</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.logoutIsOpen} onHide={this.closelogout} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ต้องการให้ออกจากระบบ
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closelogout}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" onClick={this.submitlogout}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default withRouter(Users);